import { api } from '@/lib/api/client';

export interface PrizeRedemption {
  id: number;
  redemptionCode: string;
  state: 'WON' | 'DELIVERED' | 'EXPIRED' | 'VOIDED';
  deliveryMode: 'INSTANT' | 'VOUCHER';
  xkEventId: number | null;
  xkStationId: number | null;
  stockId: number | null;
  responseId: string | null;
  wonAt: string | null;
  deliveredAt: string | null;
  expiresAt: string | null;
}

export interface RedemptionStats {
  won: number;
  delivered: number;
  expired: number;
  voided: number;
  redemptionRate: number;
}

export const redemptionApi = {
  byCode: (code: string) =>
    api.get<PrizeRedemption>(`/xk-prize-redemption/${encodeURIComponent(code)}`),
  redeem: (code: string) =>
    api.post<PrizeRedemption>('/xk-prize-redemption/redeem', { code }),
  voidOne: (id: number, reason: string) =>
    api.post<PrizeRedemption>(`/xk-prize-redemption/${id}/void`, { reason }),
  statsByEvent: (eventId: number) =>
    api.get<RedemptionStats>(`/xk-prize-redemption/stats/${eventId}`),
};
